import { render, staticRenderFns } from "./ForumResponseScrollToHelper.vue?vue&type=template&id=4bd349b9&scoped=true"
import script from "./ForumResponseScrollToHelper.vue?vue&type=script&lang=js"
export * from "./ForumResponseScrollToHelper.vue?vue&type=script&lang=js"
import style0 from "./ForumResponseScrollToHelper.vue?vue&type=style&index=0&id=4bd349b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd349b9",
  null
  
)

export default component.exports